

































import Vue from 'vue'
export default Vue.extend({
  props: {
    modified: {
      type: Boolean,
      required: true,
    },
    saving: {
      type: Boolean,
      required: true,
    },
    complete: {
      type: Boolean,
      default: false,
    },
  },
})
